<template>
  <div class="settareo">
    <div class="settareo__wrapper">
      <i class="settareo__close icon-close" @click="$emit('close-comp')"></i>
      <div class="settareo__horas" v-if="fechas.length === 1">
        <div class="settareo__horas-turno">
          <div class="settareo__horas-title">HORAS CONTRATO</div>

          <md-field
            :class="getValidationClass($v.ldata.contractual)"
            class="container__extras"
          >
            <label>Contractuales</label>
            <md-input v-model.number="ldata.contractual"></md-input>
            <span class="md-error" v-if="!$v.ldata.contractual.numeric"
              >Valor numérico requerido.</span
            >
          </md-field>

          <md-field
            class="container__extras"
          >
            <label>Tardanzas (en minutos)</label>
            <md-input v-model.number="ldata.tardiness"></md-input>
          </md-field>
        </div>
        <!-- <div class="settareo__horas-turno">
          <div class="settareo__horas-title">HORAS EXTRAS</div>

          <div class="container__extras">
            <md-field :class="getValidationClass($v.ldata.extraHours)">
              <label>Horas Extras</label>
              <md-input
                v-model.number="ldata.extraHours"
                :disabled="disableInput"
              ></md-input>
              <span class="md-error" v-if="!$v.ldata.extraHours.numeric"
                >Valor numérico requerido.</span
              >
            </md-field>
          </div>
        </div> -->
      </div>

      <div class="settareo__descansos">
        <div class="settareo__descanso grid__descanso">
          <md-switch
            v-model="ldata.status"
            :value="status.value"
            v-for="status in dayReportStatus"
            :key="status.value"
            >{{ status.label }}</md-switch
          >
        </div>
      </div>
      <md-button
        class="md-raised md-primary settareo__save"
        @click="updateTareo()"
        v-if="$store.getters.canWrite"
      >
        Guardar
      </md-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { numeric } from "vuelidate/lib/validators";

export default {
  props: {
    dateDay: Object, //de dateDayTareo
    dataReport: Object,
    today: String,
  },
  data() {
    return {
      rest: {
        restAbsence: false,
        restXAbsence: false,
        restMedical: false,
        restSubs: false,
        vacation: false,
        assistance: false,
        holiday: false,
        "licence-payed": false,
        "licence-unpayed": false,
        "temporary-disability": false,
        "sp-maternity-prepost": false,
        "si-maternity-prepost": false
      },
      //horario dia
      presDia: 0,
      extDia: 0,
      //horario noche
      presNoche: 0,
      extNoche: 0,
      extraHours: 0,

      ldata: {},
      fechas: [],
      disableInput: false,
      dayReportStatus: [
        {
          value: "assistance",
          label: "Asistencia",
        },
        {
          value: "excused-absence",
          label: "Ausencia justificada",
        },
        // DIAS NO LABORADOS Y NO SUBSIDIADOS:
        {
          value: "absence",
          label: "S.P. Falta No Justificada",
        },
        {
          value: "licence-unpayed",
          label: "S.P. Permiso o licencia concedidos por el empleador sin goce de haber",
        },
        {
          value: "medical-break",
          label: "S.I. Enfermedad o Accidente (primeros 20 días)",
        },
        {
          value: "vacation",
          label: "S.I. Descanso Vacacional",
        },
        {
          value: "licence-payed",
          label: "S.I. Licencia u otros motivos con goce de haber",
        },
        {
          value: "licence-paternity",
          label: "Días Licencia por Paternidad",
        },
        {
          value: "death",
          label: "Fallecimiento Padres, Cónyuge o Hijos.",
        },
        // DIAS SUBSIDIADOS
        {
          value: "temporary-disability",
          label: "S.I - Incapacidad Temporal (Invalidez, enfermedad y accidente)",
        },
        {
          value: "si-maternity-prepost",
          label: "S.I - Maternidad - Pre y Post Natal",
        },
        {
          value: "sp-maternity-prepost",
          label: "S.P - Maternidad - Pre y Post Natal.",
        },
      ],
      actualStatus: null,
    };
  },
  validations: {
    presDia: { numeric },
    extDia: { numeric },
    // extraHours: { numeric },
    presNoche: { numeric },
    extNoche: { numeric },
    ldata: {
      contractual: { numeric },
      diurnal: { numeric },
      nocturnal: { numeric },
      extraHours: { numeric },
    },
  },
  created() {
    this.ldata = this.dataReport;
    console.log(this.dataReport);
    // this.extraHours = this.dataReport.extraHours;
    if (this.ldata.date) {
      this.fechas = [this.ldata.date];
    } else {
      this.fechas = [];
      let difference =
        (this.dateDay.end.getTime() - this.dateDay.start.getTime()) / (1000 * 3600 * 24);

      for (let i = 0; i <= difference; i++) {
        this.fechas.push(
          new Date(
            this.dateDay.start.getFullYear(),
            this.dateDay.start.getMonth(),
            this.dateDay.start.getDate() + i
          ).toISOString()
        );
      }

      console.log(this.fechas);
    }
  },
  beforeMount() {
    console.log(this.ldata.status);
    if (this.ldata.status) {
      // this.$refs.dayhours.disabled = true
      this.disableInputs(true);

      switch (this.ldata.status) {
        case "absence":
          this.rest.restAbsence = true;
          break;
        case "assistance":
          this.rest.assistance = true;
          break;
        case "excused-absence":
          this.rest.restXAbsence = true;
          break;
        case "medical-break":
          this.rest.restMedical = true;
          break;
        case "medical-break-subsidized":
          this.rest.restSubs = true;
          break;
        case "vacation":
          this.rest.vacation = true;
          break;
        case "holiday":
          this.rest.holiday = true;
          break;
        case "licence-payed":
          this.rest["licence-payed"] = true;
          break;
        case "licence-unpayed":
          this.rest["licence-unpayed"] = true;
          break;
          case "temporary-disability":
          this.rest["temporary-disability"] = true;
          break;
          case "si-maternity-prepost":
          this.rest["si-maternity-prepost"] = true;
          break;
          case "sp-maternity-prepost":
          this.rest["sp-maternity-prepost"] = true;
          break;
        case "none":
          this.rest.none = true;
          break;
      }
    }
  },
  methods: {
    ...mapActions({
      updateReport: "updateDailyReport",
      getDayReports: "getEmployeesDailyReport",
    }),

    getValidationClass(validation) {
      if (validation.$model === null) {
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      } else {
        validation.$touch();
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      }
    },

    // toogleSwitch(val) {
    //   for (let prop in this.rest) {
    //     if (prop != val) {
    //       this.rest[prop] = false;
    //     }
    //   }

    //   if (
    //     this.rest.restAbsence ||
    //     this.rest.restMedical ||
    //     this.rest.restSubs ||
    //     this.rest.vacation ||
    //     this.rest.restXAbsence ||
    //     this.rest["licence-payed"] ||
    //     this.rest["licence-unpayed"]
    //   ) {
    //     // this.ldata.contractual = 0
    //     this.ldata.diurnal = 0;
    //     this.ldata.nocturnal = 0;
    //     // this.ldata.extraHours = 0;
    //     // this.$refs.dayhours.disabled = true
    //     this.disableInputs(true);
    //   }

    //   if (this.rest.restAbsence == true) this.ldata.status = "absence";
    //   if (this.rest.restXAbsence == true) this.ldata.status = "excused-absence";
    //   if (this.rest.restMedical == true) this.ldata.status = "medical-break";
    //   if (this.rest.restSubs == true)
    //     this.ldata.status = "medical-break-subsidized";
    //   if (this.rest.vacation == true) this.ldata.status = "vacation";
    //   if (this.rest.holiday == true) this.ldata.status = "holiday";
    //   if (this.rest["licence-payed"] == true)
    //     this.ldata.status = "licence-payed";
    //   if (this.rest["licence-unpayed"] == true)
    //     this.ldata.status = "licence-unpayed";
    //   if (this.rest.assistance == true) this.ldata.status = "assistance";
    //   this.disableInputs(false);
    //   if (
    //     this.rest.restAbsence == false &&
    //     this.rest.restXAbsence == false &&
    //     this.rest.restMedical == false &&
    //     this.rest.restSubs == false &&
    //     this.rest.vacation == false &&
    //     this.rest.assistance == false &&
    //     this.rest.holiday == false &&
    //     this.rest["licence-payed"] == false &&
    //     this.rest["licence-unpayed"] == false
    //   ) {
    //     this.ldata.status = "none";
    //     // this.ldata.contractual = 8
    //     // this.$refs['dayhours'].disabled = false
    //     // this.disableInputs(false)
    //   }
    // },

    updateTareo() {
      console.log("gaaaaaa");

      //si es un dia
      console.log(this.ldata);
      if(this.ldata.status === null ){
        this.ldata.status = 'none'
      }
      this.updateReport(Object.assign(this.ldata, { dates: this.fechas })).then(() => {
        console.log("reporte actualizado");
        this.getDayReports({
          date: this.today,
          businessID: this.$localStorage.get("businessID"),
        }).then((r) => {
          if (r.status == 200) {
            console.log("reportes actualizados");
            this.$emit("updateAnnualReport");
            this.$emit("close-comp");
          }
        });
      });
    },

    disableInputs(value) {
      // this.$refs['dayhours'].disabled = value
      // this.$refs['dayxhours'].disabled = value
      // this.$refs['nightxhours'].disabled = value
      this.disableInput = value;
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS
.md-switch {
  margin: 12px 16px 12px 0;
}
.md-switch.md-theme-default.md-checked .md-switch-container {
  background-color: rgba($b-blue, 0.38) !important;
}
.md-switch.md-theme-default.md-checked .md-switch-thumb {
  background-color: $b-blue !important;
}

// .md-button.md-theme-default.md-raised:not([disabled]).md-accent{
//   color: #fff;
// }

.msg-error {
  position: absolute;
  top: 3rem;
  color: $b-orange;
  font-size: 0.75rem;
  line-height: 0.7rem;
  margin-top: 0.5rem;
}

.md-field {
  width: 6rem;
  margin: 4px 0 18px;

  &.md-theme-default {
    width: 18rem;
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.container__extras {
  width: 18rem;
  display: flex;
  justify-content: space-between;
}
.settareo {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 600;
  @include mq($md) {
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 2000px rgba(46, 54, 103, 0.75) inset;
    background-color: rgba($b-blue, 0.95);
  }

  &__wrapper {
    height: 100%;
    background-color: white;
    padding-top: 6rem;
    position: relative;
    @include mq($md) {
      padding-top: 3rem;
      width: 30rem;
      height: 39rem;
      border-radius: 9px;
    }
    @include mq($lg) {
      padding-top: 3rem;
      width: 50rem;
      height: 39rem;
      border-radius: 9px;
    }
  }

  &__close {
    color: $b-blue-dark;
    font-size: 2rem;
    position: absolute;
    top: 1rem;
    right: 1rem;
    @include mq($lg) {
      cursor: pointer;
    }
  }
  &__horas {
    display: flex;
    flex-direction: column;
    align-items: center;
    &-turno {
      margin-bottom: 0rem;
      width: 18rem;
    }
    &-title {
      color: $b-emph;
      font-weight: 600;
      font-size: 1.1rem;
    }
    &-laborales {
      width: 15rem;
      display: flex;
      justify-content: space-between;
    }
    &-laboral {
      display: flex;
      flex-direction: column;
      color: $b-blue-dark;
      position: relative;
      input[type="text"] {
        width: 6rem;
        height: 2rem;
        border: 1px solid #d7dae2;
        border-radius: 4px;
        text-align: center;
        transition: all 0.3s ease-in-out;
        &:focus {
          border: 1px solid rgba($b-orange, 0.5);
        }
      }
    }
  }

  &__descansos {
    display: flex;
    // flex-direction: row;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
    overflow-y: scroll;
    max-height: 300px;
    // margin-top: 1rem;
  }

  &__descanso {
    user-select: none;
  }

  &__save {
    color: #fff !important;
    width: 15rem;
    margin: 1rem auto;
    display: block;
    // margin-top: 2rem;
  }
}
.grid__descanso {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 3rem;
}
</style>
